<template>
  <div class="loans_item">
    <div class="invoice-number">	
      <p> {{ id }} </p> 
    </div>
    <div class="loans_item-price">
      {{ total }}
    </div>
    <div class="loans_item-grey-text">
      <span>Date</span>
      <span>{{ date }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      default: 0,
      type: Number
    },
    total: {
      default: 0,
      type: String
    },
    date: {
      default: "",
      type: String
    }
  }
}
</script>
